import { React, useState, useEffect } from "react";
import {
  Checkbox,
  TextField,
  Autocomplete,
  styled,
  lighten, Grid, FormControl, FormHelperText
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { GetAllUsersOfADepartmentByToken } from "../../../api/endpoints";
import apiClient from "../../../api/apiClient";
import {toastErrorNotify} from "../../../helpers/toastNotify";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function DepartmentUserSelect({handleUserSelect, formSubmit, reset, initialUserValue, error}) {
  const [userData, setUserData] = useState([]);
  const [selectedBox, setSelectedBox]= useState([])
  const [formValid, setFormValid] = useState(false);
  const [, setLoading] = useState(false)

  const hasError = error !== undefined
      ? error
      : (reset === false && formSubmit && selectedBox.length === 0);

  useEffect(() => {
    (async () => {
      setLoading(true)
      try {
        const departmentUsers = await apiClient.get(GetAllUsersOfADepartmentByToken);
        setUserData(departmentUsers.data.data);
      } catch (err) {
        let errorMessage = 'En ukjent feil har oppstått.';
        if(err?.response?.data?.message)
          errorMessage = err.response.data.message;
        toastErrorNotify(errorMessage);
        console.log(err);
      }finally{
        setLoading(false)
      }
    })();
  }, []);

  useEffect(() => {
    if (!options.length || !initialUserValue?.length) return;
    const preSelected = options.filter(opt =>
        initialUserValue.some(init => String(init.id ?? init.userId) === String(opt.id))
    );
    if (preSelected.length) setSelectedBox(preSelected);
  }, [userData]);

  const options = userData.map(({ name, surname, departmentId, userId}) => ({
    name: `${name} ${surname}`,
    departmentName: `${departmentId}`,
    id : `${userId}`
  }));

  const checkOption = (option) =>{
    const check = selectedBox?.some((item)=>item.id === option.id);
    return check
  }

  const checkGroup =(group)=>{
    const groupLength = options.filter((d) => d.departmentName === group).length;
    const selectedGroupLength = selectedBox.filter(
        (d) => d.departmentName === group
    ).length;
    return groupLength === selectedGroupLength;
  };

  const selectGroup = (group)=>{
    const groupedUsers = options.filter((d) => d.departmentName === group);
    const selectedDepartments = selectedBox.filter(
        (d) => d.departmentName === group
    );
    if (selectedDepartments.length > 0) {
      setSelectedBox((prevState) => [
        ...prevState.filter((d) => d.departmentName !== group)
      ]);
    } else {
      setSelectedBox((prevState) => [...prevState, ...groupedUsers]);
    }
  }

  useEffect(() => {
    handleUserSelect(selectedBox)
    setFormValid(selectedBox.length > 0);
  }, [selectedBox]);

  useEffect(() => {
    setSelectedBox([]);
  }, [reset]);

  const GroupHeader = styled("div")(({ theme }) => ({
    top: "-8px",
    padding: "4px 10px",
    color: theme.palette.primary.main,
    backgroundColor: lighten(theme.palette.primary.light, 0.85),
  }));

  return (
      <Grid item xs={12}>
        <FormControl variant="standard" fullWidth required error={hasError}>
          <Autocomplete
              multiple
              fullWidth
              disableCloseOnSelect
              value={selectedBox}
              onChange={(_, option)=>{setSelectedBox([...option]);}}
              options={options}
              groupBy={(option) => option.departmentName}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.name === value.name}
              renderInput={(params) => (
                  <TextField
                      {...params}
                      label="Velg deltaker"
                      variant="standard"
                      placeholder="Legg deltaker"
                      required
                      error={hasError}
                  />
              )}
              renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        checked={checkOption(option)}
                    />
                    {option.name}
                  </li>
              )}
              renderGroup={(params, index) => (
                  <div key={params.group + '-' + index}>
                    <GroupHeader>
                      <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          checked={checkGroup(params.group)}
                          onClick={() => selectGroup(params.group)}
                      />
                      {params.group}
                    </GroupHeader>
                  </div>
              )}
          />
          {hasError && <FormHelperText sx={{color: 'red'}}>Dette feltet er påkrevd</FormHelperText>}
        </FormControl>
      </Grid>
  );
}